import React from "react";
import { Box } from "@mui/material";
import LoadingPlaceholderBlock from "components/common/LoadingPlaceholderBlock";
import { styles } from "../MessageDetails";
import { styles as conversationStyles } from "./ConversationItem";

export default function MessageDetailsLoader() {
  return (
    <div>
      <Box sx={styles.card}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #CED4D4",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <LoadingPlaceholderBlock
            width={"270px"}
            height={"25px"}
            borderRadius={"6px"}
            backgroundColor={"#EFEAE5"}
          />
          <Box>
            <LoadingPlaceholderBlock
              width={"130px"}
              height={"22px"}
              borderRadius={"6px"}
              backgroundColor={"#EFEAE5"}
            />
          </Box>
        </Box>

        <Box sx={{ marginBottom: "20px" }}>
          <Box sx={conversationStyles.infoContainer}>
            <Box sx={conversationStyles.author}>
              <LoadingPlaceholderBlock
                width={"130px"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
            </Box>
            <Box sx={conversationStyles.dateCreated}>
              <LoadingPlaceholderBlock
                width={"150px"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
            </Box>
          </Box>

          <Box sx={{ padding: "0px 20px", marginTop: "8px" }}>
            <Box
              sx={{
                ...conversationStyles.messageContainer,
                display: "grid",
                gap: "5px",
              }}
            >
              <LoadingPlaceholderBlock
                width={"100%"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
              <LoadingPlaceholderBlock
                width={"70%"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ marginBottom: "20px" }}>
          <Box sx={conversationStyles.infoContainer}>
            <Box sx={conversationStyles.author}>
              <LoadingPlaceholderBlock
                width={"130px"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
            </Box>
            <Box sx={conversationStyles.dateCreated}>
              <LoadingPlaceholderBlock
                width={"150px"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
            </Box>
          </Box>

          <Box sx={{ padding: "0px 20px", marginTop: "8px" }}>
            <Box
              sx={{
                ...conversationStyles.messageContainer,
                display: "grid",
                gap: "5px",
              }}
            >
              <LoadingPlaceholderBlock
                width={"100%"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
              <LoadingPlaceholderBlock
                width={"100%"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
              <LoadingPlaceholderBlock
                width={"70%"}
                height={"12px"}
                borderRadius={"6px"}
                backgroundColor={"#EFEAE5"}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
